import { getDataMapFromCommonResponse, isCommonResponseSuccessfulV2 } from "src/mentor/helpers/utilityFunctions"
import { getCPDataWithoutParams } from "../services"

export async function getClinicAppointmentsForThisClinicForCA(locationId, brandId) {
  if (!locationId) {
    return
  }
  if (!brandId) {
    return
  }

  const resp = await getCPDataWithoutParams(
    `/api/secure/clinic-assistant/clinic-appointment-type/list?clinicLocationId=${locationId}&clinicBrandId=${brandId}`,
  )
  if (resp?.status === 200 && isCommonResponseSuccessfulV2(resp)) {
    return getDataMapFromCommonResponse(resp)?.appointmentTypes || []
  }
}
